import { headlines } from "@/mocks/gossip";
import { scrollToId } from "@/lib/scroll";
import SectionHead from "./SectionHead";

const tagColor: Record<string, string> = {
  加急: "bg-brand-500 text-white",
  独家: "bg-[#241b13] text-white",
  速递: "bg-gold-500 text-white",
  首发: "bg-brand-700 text-white",
};

export default function Headlines() {
  return (
    <section id="headlines" className="relative scroll-mt-24 py-10 md:py-14">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHead
            kicker="头条首发"
            title="全网还没醒，瓜已上桌"
            desc="吃瓜前线首发片段与加急快讯，按热度实时排序，点开即看新鲜事。"
            align="left"
          />
          <span className="inline-flex items-center gap-2 self-start rounded-full border border-stone-200 bg-white px-3 py-1.5 text-[12px] text-stone-500 md:self-auto">
            <i className="ri-radio-2-line text-brand-500" />
            更新于 今天 12:56 · 共 4 条首发
          </span>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {headlines.map((h, i) => (
            <article
              key={h.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-stone-200 bg-white"
            >
              <a
                href="#exclusive"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId("exclusive");
                }}
                className="block overflow-hidden"
              >
                <div className="h-44 w-full overflow-hidden md:h-48">
                  <img
                    src={h.image}
                    alt={h.title + " 吃瓜前线速递快讯"}
                    title={h.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </a>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center gap-2">
                  <span
                    className={
                      "rounded-md px-2 py-0.5 text-[11px] font-bold " +
                      (tagColor[h.tag] || "bg-stone-100 text-stone-600")
                    }
                  >
                    {h.tag}
                  </span>
                  <span className="text-[11px] text-stone-400">{h.category}</span>
                  <span className="ml-auto inline-flex items-center gap-1 text-[11px] font-medium text-gold-600">
                    <i className="ri-fire-fill" />
                    {h.heat}°
                  </span>
                </div>
                <a
                  href="#exclusive"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToId("exclusive");
                  }}
                  className="mt-2.5 font-heading text-[16px] font-bold leading-snug text-[#241b13] group-hover:text-brand-700"
                >
                  {h.title}
                </a>
                <div className="mt-auto flex items-center gap-2 pt-3 text-[12px] text-stone-400">
                  <i className="ri-time-line" />
                  {h.time}
                  <span className="ml-auto rounded-full bg-stone-100 px-2 py-0.5 text-[11px] text-stone-500">
                    {i === 0 ? "全网首发" : "持续更新"}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}